import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { useNavigate } from 'react-router-dom';

const SupplierList = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await api.get('/suppliers/');
        const data = response.data;
        setSuppliers(Array.isArray(data) ? data : (data.suppliers || []));
      } catch (err) {
        console.error("Failed to load suppliers", err);
        setError("Failed to load suppliers.");
      } finally {
        setLoading(false);
      }
    };
    fetchSuppliers();
  }, []);

  if (loading) return <div className="container mt-4"><p>Loading suppliers...</p></div>;
  if (error) return <div className="container mt-4"><p className="text-danger">{error}</p></div>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Supplier List</h2>
        <div className="d-flex gap-2">
          <button className="btn btn-primary" onClick={() => navigate("/dashboard/suppliers/new")}>
            + Add Supplier
          </button>
          <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </button>
        </div>
      </div>
      <table className="table table-bordered mt-3">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Supplier Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Branch</th>
            <th>Relationship Staff</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {suppliers.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">No suppliers found.</td>
            </tr>
          ) : (
            suppliers.map((sup, index) => (
              <tr key={sup.id || index}>
                <td>{index + 1}</td>
                <td>{sup.supplier_name || '—'}</td>
                <td>{sup.email || '—'}</td>
                <td>{sup.phone || '—'}</td>
                <td>{sup.branch || '—'}</td>
                <td>{sup.relationship_staff || '—'}</td>
                <td>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-info text-white"
                      onClick={() => navigate(`/dashboard/suppliers/${sup.id}`)}
                      title="View Supplier"
                    >
                      👁 View
                    </button>
                    <button
                      className="btn btn-sm btn-warning"
                      onClick={() => navigate(`/dashboard/suppliers/edit/${sup.id}`)}
                      title="Edit Supplier"
                    >
                      ✏️ Edit
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SupplierList;
